import { render } from "./pegawai-list-js.vue?vue&type=template&id=0d64eed7"
import script from "./pegawai-list-js.vue?vue&type=script&lang=js"
export * from "./pegawai-list-js.vue?vue&type=script&lang=js"

import "./pegawai-list-js.vue?vue&type=style&index=0&id=0d64eed7&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__